import React from 'react';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import configureFirebase from 'services/firebase';
import tabId from 'services/tabId';
import { captureCampaignParams } from 'services/tracking_params';
import TagManager from 'react-gtm-module';
import Clarity from '@microsoft/clarity';
import colors from './styles/colors';
import './config/ReactotronConfig';
import Routes from './routes';
import history from './services/history';
import { store, persistor } from './store';
import GlobalStyle from './styles/global';

function App() {
  tabId();
  captureCampaignParams();

  Clarity.init('hulfldxvjj');

  if (process.env.NODE_ENV === 'production') TagManager.initialize({ gtmId: 'GTM-PBG9BCL' });

  if ('Notification' in window && 'serviceWorker' in navigator) configureFirebase();
  return (
    <Provider store={store}>
      <GlobalStyle />
      <PersistGate persistor={persistor}>
        <ThemeProvider theme={colors}>
          <Router history={history}>
            <Routes />
          </Router>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
